import { useCallback } from 'react';
import {
  DateRangeFilterSelect,
  DEFAULT_DATE_RANGE_FILTER_SELECT_VALUE,
} from '../../commonUI/DateRangeFilterSelect/DateRangeFilterSelect';
import { StrictDateRange } from '../../commonUI/DateRangeFilterSelect/types';

type Props = {
  onChange: (newDateRangeFilter?: StrictDateRange) => void;
};

export const DEFAULT_COLLECTIONS_RANGE_FILTER_VALUE =
  DEFAULT_DATE_RANGE_FILTER_SELECT_VALUE;

export const CollectionsDateRangeFilter = ({ onChange }: Props) => {
  const handleDateRangeFilterChange = useCallback(
    (newRangeFilter: StrictDateRange | null) => {
      if (newRangeFilter === null) {
        onChange(undefined);
      } else {
        onChange(newRangeFilter);
      }
    },
    [onChange]
  );

  return (
    <DateRangeFilterSelect
      initialValue={DEFAULT_COLLECTIONS_RANGE_FILTER_VALUE}
      onChange={handleDateRangeFilterChange}
    />
  );
};
